//Settings_Crime.ts ==============================================================
import "../Util/Prototypes";

//ESRI javascript API.
import SimpleFillSymbol from "@arcgis/core/symbols/SimpleFillSymbol";

interface iCrimeTypeDictionary {
   [key: string]: number;
}

export interface iSS {
   crimePointsMapTheme: string;
   crimePoints_layerName: string;
   zone_layerName: string;
   accessLevel_zone: number;
   addressField: string;
   crimeDateField: string;
   categoryField: string;

   crimeDate_spans: string[];
   autoSearch: boolean;
   geomSym: __esri.SimpleFillSymbol;

   accessLevel: number;
   accessLevel_neighborhood: number;
   searchRadius_list: string[];
   crimeResultsTools: string[];
   crimeResultsMoreTools: string[];

   violentCrimes_names: string[];
   propertyCrimes_names: string[];
   narcoticsCrimes_names: string[];
   otherCrimes_names: string[];

   crimeTypeDict: iCrimeTypeDictionary;
}

export const ss = {} as iSS; //Weird syntax.
const s: iSS = ss;

s.crimePointsMapTheme = "Crime Mapping";

s.crimePoints_layerName = "Crime Points";

s.zone_layerName = "Marshal Zones";

s.autoSearch = false; //Immediately search for crimes when a menu item has changed.

s.accessLevel_zone = 0;

s.addressField = "STREET_ADDRESS";
s.crimeDateField = "REPORTED_DATE";
s.categoryField = "CRIME";

//Crime date. Case sensitive field name.
s.crimeDate_spans = ["Custom", "4 days", "1 week", "2 weeks", "1 Month", "2 Months", "6 Months", "1 Year", "2 years"];

//Crime points map theme must have the first property type layer name in it.
s.crimePointsMapTheme = "Crime Points";

s.geomSym = new SimpleFillSymbol({ color: [0, 0, 0, 0], style: "solid", outline: { color: [0, 180, 255, 1], width: 2 } });

// Access levels.
s.accessLevel = 0; //Overall access level.
s.accessLevel_neighborhood = 0;

// Crime Search radiuses.
s.searchRadius_list = ["Any", "0.25", "0.5", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "20"];

s.crimeResultsTools = ["Zoom all", "Clear"];
s.crimeResultsMoreTools = ["Heat Map", "CSV"]; // "Table View", Add a leading blank space to comment out tools.

//Create a typescript dictionary.
s.crimeTypeDict = {
   "Homicide": 25,
   "Robbery Business Armed": 32,
   "Robbery Business Strong Arm / Other": 33,
   "Robbery Individual Armed": 35,
   "Robbery Individual Strong Arm / Other": 34,
   "Carjacking": 11,
   "Aggravated Assault Knife": 1,
   "Aggravated Assault Gun": 3,
   "Aggravated Assault Other": 2,
   "Sexual Offense Assault / Gun": 37,
   "Sexual Offense Assault / Other Weapon": 38,
   "Sexual Offense Assault / Other Offense": 36,
   "Sexual Offense Other": 14,
   "Weapon Offense Carrying Concealed": 12,
   "Weapon Offense Carrying Prohibited": 13,
   "Weapon Offense Firing Weapon": 21,
   "Weapon Offense Other": 31,
   "Kidnapping": 26,
   "Stalking": 4,
   "Violent Crimes Other": 19,

   "Arson": 5,
   "Burglary Business Forced Entry": 6,
   "Burglary Business Non - Forced Entry": 8,
   "Burglary Residence Forced Entry": 7,
   "Burglary Residence Non - Forced Entry": 9,
   "Theft From Auto": 28,
   "Theft From Building": 29,
   "Theft From Other": 27,
   "Theft Shoplifting": 39,
   "Theft by Receiving": 42,
   "White Collar Forgery": 22,
   "White Collar Fraud": 23,
   "Vehicle Theft Auto": 41,
   "Criminal Damage": 17,
   "Property Crimes Other": 18,

   "Cocaine": 15,
   "Marijuana": 30,
   "Synthetic Narcotic": 40,
   "Heroin": 24,
   "Narcotics Other": 16,

   "Gambling": 20,
   "Other": 10,
};

s.violentCrimes_names = [
   "Homicide",
   "Robbery Business Armed",
   "Robbery Business Strong Arm / Other",
   "Robbery Individual Armed",
   "Robbery Individual Strong Arm / Other",
   "Carjacking",
   "Aggravated Assault Knife",
   "Aggravated Assault Gun",
   "Aggravated Assault Other",
   "Sexual Offense Assault / Gun",
   "Sexual Offense Assault / Other Weapon",
   "Sexual Offense Assault / Other Offense",
   "Sexual Offense Other",
   "Weapon Offense Carrying Concealed",
   "Weapon Offense Carrying Prohibited",
   "Weapon Offense Firing Weapon",
   "Weapon Offense Other",
   "Kidnapping",
   "Stalking",
   "Violent Crimes Other"];

s.propertyCrimes_names = [
   "Arson",
   "Burglary Business Forced Entry",
   "Burglary Business Non - Forced Entry",
   "Burglary Residence Forced Entry",
   "Burglary Residence Non - Forced Entry",
   "Theft From Auto",
   "Theft From Building",
   "Theft From Other",
   "Theft Shoplifting",
   "Theft by Receiving",
   "White Collar Forgery",
   "White Collar Fraud",
   "Vehicle Theft Auto",
   "Criminal Damage",
   "Property Crimes Other"
];

s.narcoticsCrimes_names = [
   "Cocaine",
   "Marijuana",
   "Synthetic Narcotic",
   "Heroin",
   "Narcotics Other"
];

s.otherCrimes_names = [
   "Gambling",
   "Other",
];
